import {RestrictedRouteModuleConfiguration} from "../model/UserPermission";
import BranchModuleConfig from "../../branches/BranchesModuleConfiguration";
import LqbFundedLogModuleConfiguration from "../../logging_lqb_funded/lqbFundedLoggingModuleConfiguration";
import UsersModuleConfiguration from "../../users/UsersModuleConfiguration";
import RedirectModuleConfiguration from "../../redirect/RedirectModuleConfiguration";
import StatisticModuleConfiguration from "../../statistic/StatisticModuleConfiguration";
import CalculationModuleConfiguration from "../../calculations/CalculationsModuleConfiguration";
import CustomersModuleConfiguration from "../../customers/CustomersModuleConfiguration";
import CalculationLoggingModuleConfiguration from "../../logging_calculation/calculationsLoggingModuleConfiguration";
import OpportunitiesModuleConfiguration from "../../opportunities/opportunitiesModuleConfiguration";
import SchedulingModuleConfiguration from "../../scheduling/SchedulingModuleConfiguration";
import {MainModuleConfiguration} from "../../main/MainModuleConfiguration";
import CustomerProfileModuleConfiguration from "../../customer_profile/CustomerProfileModuleConfiguration";
import ManualImportModuleConfiguration from "../../manual_import/ManualImportModuleConfiguration";
import CampaignsModuleConfiguration from "../../campaigns/CampaignsModuleConfiguration";
import ConversionLogModuleConfiguration from "../../conversion_log/ConversionLogModuleConfiguration";
import DirectMailerLogsModuleConfiguration from "../../direct_mailer_logs/DirectMailerLogsModuleConfiguration";
import LeadModuleConfiguration from "../../lead/LeadModuleConfiguration";
import PartnerModuleConfiguration from "../../partner/PartnerModuleConfiguration";
import LeadProfileModuleConfiguration from "../../lead/LeadProfileModuleConfiguration";
import PartnerProfileModuleConfiguration from "../../partner/PartnerProfileModuleConfiguration";
import {
    AngularMaterialConfigurationModuleConfiguration
} from "modules/configurations/MaterialConfigurationsModuleConfiguration";
import {MainServiceModule} from "modules/main_service_module/MainServiceModuleConfiguration";
import {UtilsModule} from "modules/utils/utilsModuleConfiguration";
import {LOADER_MODULE} from "modules/loader/loaderModuleConfiguration";
import {removeDuplicatesAndEmptyStrings} from "modules/utils/StringUtils";
import {collect} from "modules/utils/CollectionUtils";
import {Principle} from "modules/brand_service/model/Principle";
import UserSettingsConfiguration from "modules/user_settings/UserSettingsConfiguration";
import {UserSettingsModuleName} from "modules/utils/names/optionalModuleNames";


/*
* userGrantedAuthorities is being set inside of index.html through thymeleaf
*/


const ALL_MODULES_CONFIGURATIONS = [
    //User section
    MainModuleConfiguration,
    AngularMaterialConfigurationModuleConfiguration,
    MainServiceModule,
    UtilsModule,
    LOADER_MODULE,
    OpportunitiesModuleConfiguration,
    CustomersModuleConfiguration,
    LeadModuleConfiguration,
    LeadProfileModuleConfiguration,
    PartnerModuleConfiguration,
    PartnerProfileModuleConfiguration,
    CustomerProfileModuleConfiguration,
    CalculationModuleConfiguration,
    CampaignsModuleConfiguration,
    DirectMailerLogsModuleConfiguration,
    CalculationLoggingModuleConfiguration,
    LqbFundedLogModuleConfiguration,
    StatisticModuleConfiguration,
    ConversionLogModuleConfiguration,
    UserSettingsConfiguration,
    //Admin Section
    BranchModuleConfig,
    SchedulingModuleConfiguration,
    RedirectModuleConfiguration,
    UsersModuleConfiguration,
    ManualImportModuleConfiguration
];

const SETTINGS_CONFIGURATIONS = [
    UserSettingsConfiguration,
];


export class UserAuthorityService {

    private permittedModulesConfigurations: RestrictedRouteModuleConfiguration[];


    constructor(private principle: Principle) {
    }

    public getPermittedModulesConfigurations(): RestrictedRouteModuleConfiguration[] {
        if (!this.permittedModulesConfigurations) {
            this.permittedModulesConfigurations = this.evaluatePermittedModulesConfiguration();
        }
        return this.permittedModulesConfigurations;
    };

    public getSettingsConfigurations() {
        return SETTINGS_CONFIGURATIONS;
    }

    private evaluatePermittedModulesConfiguration() {
        const {userAccessLevels} = this.principle;
        const userGrantedAuthorities = userAccessLevels
            .filter(a => a.status)
            .map(a => a.authorityName);

        return ALL_MODULES_CONFIGURATIONS
            .filter(moduleConfig => {
                    const moduleRequiredAccessLevelNames = moduleConfig.requiredAccessLevels;
                    if (moduleRequiredAccessLevelNames.length) {
                        return moduleRequiredAccessLevelNames
                            .some(accessLevel => userGrantedAuthorities.includes(accessLevel));
                    }
                    return true;
                }
            );
    }

    getPermittedModulesNavigationItems = () => {
        let allNavigationItems = [];
        let permittedModulesConfigurations = this.getPermittedModulesConfigurations()
            .filter(mod => mod.name != UserSettingsModuleName);

        for (const permission of permittedModulesConfigurations) {
            for (const navigationItem of permission.navigationItems) {
                allNavigationItems.push(navigationItem);
            }
        }
        return allNavigationItems;
    };

    getUserSettingsItems = () => {
        let allNavigationItems = [];
        let permittedModulesConfigurations = this.getSettingsConfigurations();
        let navigationItems = permittedModulesConfigurations
            .find(s => s.controllerModulesNames.find(n => n == UserSettingsModuleName) == UserSettingsModuleName)
            .navigationItems;
        for (const navItem of navigationItems) {
            allNavigationItems.push(navItem)
        }
        return allNavigationItems;
    }

    getPermittedModulesRouterConfigs = () => {
        return this.getPermittedModulesConfigurations().map((perm) => perm.routerConfig);
    }

    evaluateDependenciesModulesNamesWithoutRouter(): string[] {
        const allPermittedModulesNames = this.getPermittedModulesConfigurations();
        const allModuleNames = allPermittedModulesNames
            .map(val => val.getAllModulesNames())
            .reduce(collect, [])
        return removeDuplicatesAndEmptyStrings(allModuleNames);
    }

}


